export default {
  title: 'Regulamin',
  type: 'object',
  properties: {
    name: {
      title: 'schema.terms.name',
      type: 'string',
      fieldRequired: true
    },
    order: {
      title: 'schema.terms.order',
      type: 'number',
      fieldRequired: true
    },
    required: {
      title: 'schema.terms.required',
      type: 'boolean',
      fieldRequired: true
    },
    content: {
      title: 'schema.terms.content',
      type: 'string',
      fieldRequired: true
    },
    start: {
      title: 'schema.terms.start',
      type: 'string',
      format: 'date',
      fieldRequired: true
    },
    acceptText: {
      title: 'schema.terms.acceptText',
      type: 'string',
      fieldRequired: true
    }
  }
};
